import React, { version } from "react";
import {
    Input,
    Select,
    DatePicker,
    Button,
    Space,
    Row,
    Col,
    Dropdown,
    Checkbox,
    Modal,
    Image,
    Tooltip, Upload, Drawer, Form,
    message
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import UserLoginReportStore from "../store/UserLoginReportStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg"; import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";

import config from "../config";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import FairDetailsStore from "../store/FareDetailsStore";
import { CloseOutlined, DownCircleOutlined, SendOutlined } from "@ant-design/icons";
import CompanyStore from "../store/CompanyStore";
// import { json } from "react-router-dom";

dayjs.extend(customParseFormat);
const { Dragger } = Upload;
const { RangePicker } = DatePicker;
const { Option } = Select;

class UploadTarrifJson extends React.Component {
    formRef = React.createRef();

    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.userLoginReportStore = new UserLoginReportStore();
        this.workingHoursStore = new VehicleWorkingHoursStore();
        this.fareDetailsStore = new FairDetailsStore(this);
        this.companyStore = new CompanyStore(this);


        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: "",
            comp_value: "",
            date: "",
            time: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
            modalVisible: false,
            column: "",
            filter: "",
            showMonthPopup: false,
            Notcompany: false,
            Notdate: false,
            disabledIds: [],
            disabledMap: {},
            openDeleteModal: false,
            disabledSendIds: []
        };


        this.columns = [
            {
                title: context.translate("_TAXI_"),
                dataIndex: "vehicleNo",
                key: "vehicleNo",
                ellipsis: { showTitle: true },
                width: 15,
            },
            {
                title: context.translate("_VERSION_"),
                dataIndex: "version",
                ellipsis: { showTitle: true },
                width: 15,
            },
            {
                title: context.translate("_VEHICLE_STATUS_"),
                dataIndex: "status",
                ellipsis: { showTitle: true },
                width: 15,
            },
            {
                title: context.translate("_ACTION_"),
                dataIndex: "action",
                align: "center",
                width: 15,
                render: (_, record) => {
                    const rowId = record.Id;
                    const isDisabled = !!this.state.disabledMap[rowId];

                    return (
                        <>
                            <Space>
                                {record.tarrifStatus < 10 && (
                                    <Space>
                                        <Tooltip
                                            title={
                                                isDisabled
                                                    ? "Please wait 30 seconds..."
                                                    : context.translate("_SEND_COMMAND_")
                                            }
                                        >
                                            <span>
                                                <SendOutlined
                                                    style={{
                                                        fontSize: "15px",
                                                        marginTop: "5px",
                                                        color: isDisabled ? "#ccc" : "#1890ff",
                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                        opacity: isDisabled ? 0.5 : 1
                                                    }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (isDisabled) return;

                                                        // disable
                                                        this.setState(prev => ({
                                                            disabledMap: {
                                                                ...prev.disabledMap,
                                                                [rowId]: true
                                                            }
                                                        }));

                                                        // enable after 30 sec
                                                        setTimeout(() => {
                                                            this.setState(prev => {
                                                                const updated = { ...prev.disabledMap };
                                                                delete updated[rowId];
                                                                return { disabledMap: updated };
                                                            });
                                                        }, 30000);

                                                        const payload = {
                                                            ...record,
                                                            vehicleId: [record.vehicleId]
                                                        };

                                                        this.setState({ commandRecords: payload });

                                                        message.info("Tariff OTA Update in process, Please wait");
                                                        this.sendCommand(payload);
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                        <Tooltip
                                            title={this.context.translate(
                                                "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                                            )}
                                        >
                                            {this.props.canDelete("vehicledistancelist") && (
                                                <Image
                                                    src={require("../assets/images/NewDesign/Delete.png")}
                                                    style={{ cursor: "pointer", width: "15px" }}
                                                    onClick={() =>
                                                        this.setState({
                                                            openDeleteModal: true,
                                                            deleteData: record,
                                                        })
                                                    }
                                                ></Image>
                                            )}
                                        </Tooltip>
                                    </Space>
                                )}


                                <Tooltip
                                    placement="bottom"
                                    title={context.translate("_DOWNLOAD_TARIFF_")}
                                    color={config.tooltipColorEdit}
                                >
                                    <DownCircleOutlined
                                        style={{ fontSize: "15px", marginTop: "5px" }}
                                        onClick={() => {
                                            this.downloadTarrif(record);
                                        }}
                                    />{" "}
                                </Tooltip>
                            </Space>
                        </>


                    );
                }
            },

        ]
    }

    async onDelete(record) {
        console.log(record);
        const response = await this.fareDetailsStore.deleteTariffrecord(record.Id);
        //  console.log(response.data.success)
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.setState({ openDeleteModal: false });
            this.refreshList();
        } else {
            message.error(response.data.message);
        }
    }
    async sendCommand(data) {
        this.setState({ loading: true });

        // data.units = data.map(row => ({
        //     imei: row.imei,
        //     otaId: row.Id
        // }));
        data.units = [{
            otaId: data.Id,
            unitNo: data.imei,

        }]
        console.log(data);
        // const data = this.state.commandRecords
        await this.fareDetailsStore.sendCommand(data);
        this.setState({ loading: false });
    }
    async sendBulkCommand() {
        message.info("Tariff OTA Update in process, Please wait");

        this.setState({ loading: true });

        const records = this.state.commandRecords;

        if (!records || records.length === 0) {
            this.setState({ loading: false });
            return;
        }

        const ids = records.map(item => item.Id);
        const updatedMap = { ...this.state.disabledMap };

        ids.forEach(id => {
            updatedMap[id] = true;
        });

        this.setState({
            disabledMap: updatedMap
        });

        setTimeout(() => {
            this.setState(prev => {
                const newMap = { ...prev.disabledMap };
                ids.forEach(id => delete newMap[id]);
                return { disabledMap: newMap };
            });
        }, 30000);

        console.log("object", records);

        const latestRecords = Object.values(
            records.reduce((acc, item) => {
                const key = item.imei;

                if (
                    !acc[key] ||
                    new Date(item.createdAt) > new Date(acc[key].createdAt)
                ) {
                    acc[key] = item;
                }

                return acc;
            }, {})
        );

        const latestVersionRecord = latestRecords.reduce((latest, item) => {
            if (!latest || new Date(item.createdAt) > new Date(latest.createdAt)) {
                return item;
            }
            return latest;
        }, null);

        const data = {
            companyId: this.state.companyId,
            units: records.map(item => ({
                otaId: item.Id,
                unitNo: item.imei
            })),
            version: latestVersionRecord?.version
        };

        console.log(data);

        await this.fareDetailsStore.sendCommand(data);

        this.refreshList();

        this.setState({
            loading: false,
            selectedRecords: [],
            commandRecords: []
        });
    }
    async componentDidMount() {
        this.setState({ pageSize: 50 });
        await this.setState({ column: this.state.selectedColumns });

        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
            this.getVehicleList(companyId);
            this.showData();
        }

        await this.setState({ listUpdated: 1 });

        // await this.setState({ listUpdated: 1 });
    }

    async handleTableChange(pagination) {
        //   console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }

    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            currentPage: 1,
            pageSize: 50,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);

        await this.setState({ comp_value: singleData });

        await this.setState({ Notcompany: false });
        await this.setState({ currentPage: 1, companyId: comp?.value });
        // this.handleSearch();
    }

    async handleSearch() {
        await this.userLoginReportStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            pageNo: this.state.currentPage,
        });
        await this.setState({ listUpdated: 1 }); //need to reload data
    }
    showData = async () => {
        this.setState({ loading: true });
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (!this.state.fromDate) {
            this.setState({ Notdate: true });
        } else {
            this.setState({ Notdate: false });
        }
        const data = {
            companyId: this.state.companyId,
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            pageNo: this.state.currentPage,
        }

        await this.fareDetailsStore.getTarrif(data);
        this.setState({ listUpdated: 1, loading: false });
    };

    refreshList = async () => {
        this.setState({
            loading: false,
            selectedRecords: [],
            commandRecords: []
        });
        await this.setState({ loading: false, current: 1, currentPage: 1 });
        await this.showData();
    };
    getVehicleList = async (companyId) => {
        // await this.workingHoursStore.getVehicleGroup({
        //     companyId: comp.value,
        //     userId: this.props.getUserData().userId,
        //     isadmin: this.props.getUserData().isadmin,
        // });
        const data = await this.workingHoursStore.getAssignVehicles({
            companyId: companyId,
        });
        this.setState({ loadData: 1 });
        console.log(await this.workingHoursStore.assignAssetList)
    };
    handleSelectAll = (e) => {
        const checked = e.target.checked;
        this.setState({ selectedVehicle: checked });

        if (checked) {
            const arr = this.workingHoursStore?.assignAssetList.map(
                (option) => option.vehicleId
            ) || [];

            this.formRef.current.setFieldsValue({ vehicleId: arr });
            this.setState({ selectedValues: arr });

        } else {
            this.formRef.current.setFieldsValue({ vehicleId: [] });
            this.setState({ selectedValues: [] });
        }
    };

    validateFile = (file) => {
        this.setState({ fileList: file });

        const maxSize = config.UploadExcelSize;
        if (file.type !== "application/json") {
            message.error("Only JSON files are allowed");
            return Upload.LIST_IGNORE;
        }

        if (file.size > maxSize) {
            message.error("File size must be less than or equal to 1MB");
            return false;
        }
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const jsonData = JSON.parse(e.target.result);

                console.log("Parsed JSON:", jsonData);

                // Store in state
                this.setState({
                    jsonData: jsonData,
                    fileList: [file],
                    version: jsonData.version
                });

            } catch (error) {
                message.error("Invalid JSON format");
            }
        };

        reader.readAsText(file);
        return false;
    };
    onExcelSubmit = async () => {
        this.setState({ loading: true });
        const values = this.formRef.current.getFieldsValue();

        const postdata = {

            companyId: this.state.companyId,
            vehicleId: values.vehicleId,
            vId: values.vehicleId,
            jsonData: this.state.jsonData,
            version: this.state.version
        }
        console.log("Final Payload:", postdata);
        const result = await this.fareDetailsStore.saveTarrif(postdata);
        console.log(result)
        this.setState({ loading: true });

        if (result.success == 'S') {
            message.success("Uploaded Successfully");
            const singleData = await this.companyStore.getCompanyDataById(this.state.companyId);
            console.log(singleData)
            this.setState({ showUpload: false, comp_value: singleData });
            await this.showData();
        } else {
            message.error(result.message);
        }


    }
    /*handleVehicleChange = (selectedVehicleIds) => {
        console.log("Selected vehicleId:", selectedVehicleIds);
    
        // this.setState({
        //     vehicleId: selectedVehicleIds
        // });
    };*/
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" })
        }
    };

    downloadTarrif(record) {
        const data = {
            otaId: record.Id
        }
        this.fareDetailsStore.downloadVehicleTarrif(data);
    }

    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                {/* <CompanyAutocomplete
                                    className="searchInput"
                                    allowClear={true}
                                    onChange={(value) => this.handleChange(value)}
                                    style={{ width: 150 }}
                                    status={this.state.Notcompany ? "error" : false}
                                    value={this.state.comp_value ? this.state.comp_value : null}

                                /> */}
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    value={this.state.comp_value ? this.state.comp_value : null}
                                    style={{ width: 200 }}
                                />
                                <RangePicker
                                    placeholder={[
                                        this.context.translate("_FROM_DATE_TIME_"),
                                        this.context.translate("_TO_DATETIME_"),
                                    ]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    // disabledDate={(current) => {
                                    //   return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [dayjs().startOf("day"), dayjs()],
                                    }}
                                    status={this.state.Notdate ? "error" : false}
                                    defaultValue={[dayjs().startOf("day"), dayjs()]}
                                />

                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();
                                    }}
                                >
                                    {" "}
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>

                            </Space>
                        </Col>

                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Tooltip
                                    title={this.context.translate("_UPLOAD_")}
                                    placement="bottom"
                                >
                                    <Button
                                        className="uploadExcelButton"
                                        onClick={() => this.setState({ showUpload: true })}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                            }}
                                            src={uploadIcon}
                                        />
                                    </Button>
                                </Tooltip>

                                {(
                                    <Button
                                        className="uploadExcelButton"
                                        onClick={() => this.sendBulkCommand()}
                                        disabled={this.state.commandRecords?.length > 0 ? false : true}
                                    >
                                        <Tooltip
                                            title={this.context.translate("_SEND_COMMAND_")}
                                            placement="bottom"
                                        >
                                            <SendOutlined />
                                        </Tooltip>
                                    </Button>
                                )}

                            </Space>
                        </Col>
                    </Row>


                    <ListTable
                        rowKey="Id"
                        rowSelection={{
                            columnWidth: 2,
                            preserveSelectedRowKeys: true,
                            selectedRowKeys: this.state.selectedRecords,
                            getCheckboxProps: (record) => ({
                                disabled: record.tarrifStatus === 10, // disable selection when status = 10
                            }),
                            onChange: async (selectedRowKeys, selectedRows) => {
                                console.log(selectedRows);
                                await this.setState({
                                    selectedRecords: selectedRowKeys,
                                    commandRecords: selectedRows
                                });

                            },
                        }}
                        currentPage={this.state.currentPage}
                        total={this.fareDetailsStore?.totaltarrifVehicles}
                        columns={this.columns}
                        pageSize={this.state.pageSize}
                        dataSource={this.fareDetailsStore?.tarrifVehicles}
                        loading={this.fareDetailsStore?.loading}
                        onChange={this.handleTableChange}
                    />
                    {this.state.showUpload && (
                        <>
                            <Drawer
                                className="uploadExcelDrawer"
                                width={716}
                                closeIcon={false}
                                open={this.state.showUpload}
                                placement={
                                    this.context.locale.language === "arabic" ? "left" : "right"
                                }
                                footer={false}
                                title={
                                    <div className="uploadExcelTitle">
                                        <Image
                                            style={{ height: "60px" }}
                                            src={UploadTitleIcon}
                                        ></Image>
                                        <span>
                                            {" "}
                                            {this.context.translate("_UPLOAD_TARRIF_JSON_")}
                                        </span>
                                    </div>
                                }
                                maskClosable={false}
                                onOk={() => this.setState({ showUpload: false })}
                                onCancel={() =>
                                    this.setState({
                                        showUpload: false,
                                        excelFile: "",
                                    })
                                }
                            >
                                <Form
                                    ref={this.formRef}
                                    name="excelimport"
                                    layout="vertical"
                                    onFinish={this.onExcelSubmit}
                                    style={{ margin: "16px 0px" }}
                                >
                                    {(this.props.getUserData().isadmin === -1 ||
                                        this.props.getUserData().isadmin === 3) && (
                                            <Form.Item
                                                name="companyId"
                                                className="uploadCompany"
                                                label={
                                                    <span>
                                                        {this.context.translate("_ACCOUNT_")}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                rules={[{ required: true }]}
                                                required={false}
                                            >
                                                <CompanyAutocomplete

                                                    onChange={(input) => {
                                                        this.setState({ companyId: input.value });
                                                        this.getVehicleList(input.value);

                                                    }}
                                                />
                                            </Form.Item>
                                        )}
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        <Form.Item
                                            name="vehicleId"
                                            style={{ width: "90%" }}
                                            label={
                                                <span>
                                                    {this.context.translate("_ASSIGN_ASSET_")}{" "}
                                                    <span style={{ color: "red" }}>*</span>
                                                </span>
                                            }
                                            required={false}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        this.context.translate("_SELECT_VEHICLES_"),
                                                },
                                            ]}

                                        >
                                            <Select
                                                className="select-dropdown"
                                                placeholder={this.context.translate(
                                                    "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                                                )}
                                                // placeholder="Select Asset"
                                                maxTagCount={"responsive"}
                                                mode="multiple"
                                                showSearch
                                                fieldNames={{
                                                    value: "vehicleId",
                                                    label: "vehicleNo",
                                                }}
                                                optionFilterProp="children"
                                                options={this.workingHoursStore?.assignAssetList}
                                            // onChange={this.handleVehicleChange}
                                            />
                                        </Form.Item>

                                        <Form.Item label=" ">
                                            <Checkbox
                                                checked={this.state.selectedVehicle}
                                                onChange={(e) => {
                                                    console.log(e);
                                                    this.handleSelectAll(e);
                                                }}
                                            >
                                                {/* All */}
                                                {this.context.translate("_ALL_")}{" "}
                                            </Checkbox>
                                        </Form.Item>
                                    </div>
                                    <Dragger
                                        onRemove={() =>
                                            this.setState({ jsonFile: "", fileList: [] })
                                        }
                                        name="jsonFile"
                                        listType="text"

                                        // customRequest={(options) => this.uploadFunction(options)}
                                        onChange={this.getUploadData}
                                        beforeUpload={(file) => this.validateFile(file)}
                                        maxCount={1}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "20px",
                                            }}
                                        >
                                            <div>
                                                <Image
                                                    style={{ width: "90px" }}
                                                    src={uploadOutlined}
                                                ></Image>
                                            </div>
                                            <div className="uploadFileText">
                                                <span>
                                                    {this.context.translate("_UPLOAD_JSON_FILE_")}
                                                </span>
                                                <p>
                                                    {this.context.translate("_UPLOAD_TEXT_")}{" "}
                                                    <span
                                                        style={{
                                                            color: "var(--Blue-6, #1890FF)",
                                                            fontSize: "14px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                                                    </span>
                                                    {this.context.translate("_UPLOAD_TEXT_2_")}
                                                </p>
                                            </div>
                                        </div>
                                    </Dragger>



                                    <Space className="uploadFooter">
                                        <Button
                                            className="uploadCancelButton"
                                            onClick={() =>
                                                this.setState({
                                                    showUpload: false,
                                                    excelFile: "",
                                                })
                                            }
                                        >
                                            {this.context.translate(
                                                "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                            )}
                                        </Button>
                                        <Button
                                            htmlType="submit"
                                            className="uploadButton"
                                        >
                                            {this.context.translate("_UPLOAD_")}
                                        </Button>
                                    </Space>
                                </Form>
                            </Drawer>{" "}
                        </>
                    )}
                </div>

                {this.state.openDeleteModal && (
                    <Modal
                        maskClosable={false}
                        title={
                            <div className="deleteModalTitle">
                                <span>
                                    {" "}
                                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                                </span>
                                <CloseOutlined
                                    style={{ cursor: "pointer", color: "white" }}
                                    onClick={() => this.setState({ openDeleteModal: false })}
                                />
                            </div>
                        }
                        className="deleteModal"
                        description="Are you sure you want to delete this Item? This action cannot be undone."
                        centered
                        open={this.state.openDeleteModal}
                        footer={null}
                        width={400}
                        closable={false}
                    >
                        <div className="deleteModalText">
                            <p>{this.context.translate("_DELETE_STATUS_")}</p>
                        </div>
                        <div className="deleteModalButtons">
                            <Button
                                className="deleteModalCancelButton"
                                onClick={() => this.setState({ openDeleteModal: false })}
                            >
                                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>

                            <Button
                                className="deleteModalOkButton"
                                onClick={() => this.onDelete(this.state.deleteData)}
                            >
                                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                            </Button>
                        </div>
                    </Modal>
                )}
            </>
        );
    }
}
UploadTarrifJson.contextType = StoreContext;
export default observer(withRouter(UploadTarrifJson));
